import ICCSI2022Cover from './imgs/ICCSI2022.webp';
import ICCSI2023Cover from './imgs/ICCSI2023.webp';

const legacyNewsImages = {
  'ICCSI2022.webp': ICCSI2022Cover,
  'ICCSI2023.webp': ICCSI2023Cover,
};

export function resolveNewsImage(value) {
  if (!value) return '';
  const key = String(value).split('/').pop();
  return legacyNewsImages[key] || value;
}
